import { SANCTIONS_ROWS_PER_PAGE } from '../../config/settings/constant'
import {
  CLOSE_SANCTION_VOID_DIALOG,
  GET_HISTORICAL_SANCTIONS_LIST,
  GET_HISTORICAL_SANCTIONS_LIST_ERROR,
  GET_HISTORICAL_SANCTIONS_LIST_SUCCESS,
  GET_SANCTION_VOID_INFO,
  GET_SANCTION_VOID_INFO_ERROR,
  GET_SANCTION_VOID_INFO_SUCCESS,
  OPEN_SANCTION_VOID_DIALOG
} from './HistoricalSanctionsList.actions'

const initialState = {
  data: [],
  error: null,
  itemsPerPage: SANCTIONS_ROWS_PER_PAGE,
  keyword: '',
  loading: true,
  page: 1,
  searching: false,
  showSanctionVoidDialog: false,
  totalPages: 0,
  totalRecords: 0,
  sanctionVoidInfo: {
    data: {
      documentFile: '',
      documentType: '',
      resolutionNumber: '',
      supportDocumentDate: ''
    },
    error: null,
    loading: true
  }
}

/**
 * The HistoricalSanctionsList reducer.
 */
const historicalSanctionsListReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case CLOSE_SANCTION_VOID_DIALOG: {
      return {
        ...state,
        showSanctionVoidDialog: false,
        sanctionVoidInfo: { ...initialState.sanctionVoidInfo }
      }
    }

    case GET_HISTORICAL_SANCTIONS_LIST: {
      return {
        ...state,
        error: null,
        loading: payload.loading || state.loading,
        searching: payload.searching || state.searching
      }
    }
    case GET_HISTORICAL_SANCTIONS_LIST_ERROR: {
      return { ...state, error: payload.error, loading: false, searching: false }
    }
    case GET_HISTORICAL_SANCTIONS_LIST_SUCCESS: {
      return {
        ...state,
        data: payload.data,
        error: null,
        itemsPerPage: payload.itemsPerPage,
        keyword: payload.keyword,
        loading: false,
        page: payload.page,
        searching: false,
        totalPages: payload.totalPages,
        totalRecords: payload.totalRecords
      }
    }

    case GET_SANCTION_VOID_INFO: {
      return { ...state, sanctionVoidInfo: { ...state.sanctionVoidInfo, error: null, loading: true } }
    }
    case GET_SANCTION_VOID_INFO_ERROR: {
      return { ...state, sanctionVoidInfo: { ...state.sanctionVoidInfo, error: payload.error, loading: false } }
    }
    case GET_SANCTION_VOID_INFO_SUCCESS: {
      return {
        ...state,
        sanctionVoidInfo: {
          ...state.sanctionVoidInfo,
          data: {
            ...state.sanctionVoidInfo.data,
            ...payload.data
          },
          loading: false
        }
      }
    }

    case OPEN_SANCTION_VOID_DIALOG: {
      return { ...state, showSanctionVoidDialog: true }
    }

    default: {
      return state
    }
  }
}

export default historicalSanctionsListReducer
